import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/home/index.vue'),
    name: 'Home'
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // 防止重复路由报错
  // if (to.path === from.path) {
  //   return false
  // }
  next()
})

export default router
